function OurStory() {
  return (
    <div className="about__ourstory-container column">
      <div className="about__ourstory-background">
      </div>
      <div className="about__ourstory-content column">
        <div className="about__ourstory-title">
          <h1>회사 소개</h1>
        </div>
        <div className="about__ourstory-wrapper background__gradient">
          <div className="about__ourstory-text column">
            <p>라이프스팬 뉴질랜드는 뉴질랜드산 고품질의 천연 영양제를 생산합니다. 저희는 과학적으로 입증된 안전하고 효과적인 성분을 사용해 고객님들의 건강에 도움을 드리는 것을 최우선으로 생각합니다. 무엇보다도 건강에 도움이 된다고 확신하지 않는 제품은 판매하지 않을 것입니다. 그것이 최고 인기제품이더라도 말이죠. </p>
            <p>저희는 전 세계에 저희 제품을 판매하는 공급처들과 우수한 고객서비스의 기록을 가지고 있습니다. 그리고 여러분도 그 중 한 명이 될 수 있습니다. </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurStory;